const completedData = [
  {
    user: {
      name: "Sam Altman",
      mail: "samaltman123@gmail.com",
    },
    riskLevel: "Medium",
    actionReason: "Flagged",
    timeToClose: "14 days",
    dateAddedOn: "12 Oct, 2023",
    actionTakenBy: {
      name: "Neil",
      mail: "neil@onjuno.com",
    },
  },
  {
    user: {
      name: "Sameer Choubey",
      mail: "sameer123@gmail.com",
    },
    riskLevel: "High",
    actionReason: "Closed",
    timeToClose: "14 days",
    dateAddedOn: "12 Oct, 2023",
    actionTakenBy: {
      name: "Pratik",
      mail: "pratik@onjuno.com",
    },
  },
  {
    user: {
      name: "Adarsh Panikar",
      mail: "adarsh@onjuno.com",
    },
    riskLevel: "Low",
    actionReason: "Cleared",
    timeToClose: "15 days",
    dateAddedOn: "12 Oct, 2023",
    actionTakenBy: {
      name: "Prashanth",
      mail: "prashanth@onjuno.com",
    },
  },
  {
    user: {
      name: "Pratik Shetty",
      mail: "pratik3@gmail.com",
    },
    riskLevel: "High",
    actionReason: "SOI requested",
    timeToClose: "15 days",
    dateAddedOn: "12 Oct, 2023",
    actionTakenBy: {
      name: "Rasleen Kaur",
      mail: "rasleen@onjuno.com",
    },
  },
  {
    user: {
      name: "Elon Musk",
      mail: "elon@twitterceo.com",
    },
    riskLevel: "Low",
    actionReason: "Flagged",
    timeToClose: "15 days",
    dateAddedOn: "12 Oct, 2023",
    actionTakenBy: {
      name: "Pratik Shetty",
      mail: "pratik@onjuno.com",
    },
  },
  {
    user: {
      name: "Trina Kundu",
      mail: "trina@onjuno.com",
    },
    riskLevel: "Low",
    actionReason: "Closed",
    timeToClose: "15 days",
    dateAddedOn: "12 Oct, 2023",
    actionTakenBy: {
      name: "Varun Deshpande",
      mail: "varun@onjuno.com",
    },
  },
];

export default completedData;
